import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import AddStandardItems from './si-selection';
import {
  GET_BID_LINES_WITH_SOL_LINE,
  GET_MULTIPLE_OPTIONS_FOR_BID,
} from '../bids.gql';

const SelectStandardItemForBid = () => {
  const { bidId } = useParams();

  const { data: selectedBidLines, loading: isBidLineDataLoading } = useQuery(
    GET_BID_LINES_WITH_SOL_LINE,
    {
      fetchPolicy: 'network-only',
      variables: { bidId: +bidId },
      skip: !bidId,
    },
  );

  const { data: fvsPrograms } = useQuery(GET_MULTIPLE_OPTIONS_FOR_BID, {
    fetchPolicy: 'network-only',
    variables: {
      options: [
        {
          model: 'StandardsCodeModel',
          label: 'title',
          value: 'code',
          filter: {
            operator: 'EQ',
            key: 'category',
            value: 'Program',
          },
          uniqueKey: 'program',
          includeValueInLabel: true,
        },
      ],
    },
  });

  const selectedStandardItems = useMemo(() => {
    let uniqueArray = [];
    const bidLines = selectedBidLines?.getBidLines;
    if (!isBidLineDataLoading && bidLines) {
      const uniqueSolLineIds = new Set(
        bidLines
          .filter((bl) => !bl.solicitationLine.deletedAt)
          .map((bl) => bl.solicitationLineId),
      );
      uniqueArray = [...uniqueSolLineIds].map((id) =>
        bidLines.find((bl) => bl.solicitationLineId === id),
      );
    }
    return uniqueArray.map((item) => ({
      vehGrp: item.standardItem?.vehicleGroup?.title,
      soliLineSi: `${item.standardItem?.id}-${item.solicitationLineId}`,
      scheduleLine: item.scheduleLine,
    }));
  }, [selectedBidLines, isBidLineDataLoading]);

  return (
    <div className="grid-col">
      <AddStandardItems
        selectedBidLines={selectedStandardItems}
        fvsPrograms={fvsPrograms?.getMultipleOptions}
      />
    </div>
  );
};

export default SelectStandardItemForBid;
